import {
  MolliePayment,
  MolliePaymentRequest,
  TideClientConfig,
} from "../types";

import { post } from "./common-client";

const ENDPOINT = "/api/mollie";
const ENDPOINT_CREATE_PAYMENTS = `${ENDPOINT}/create-payment`;

/**
 * api/mollie/create-payment
 * @param request
 * @returns mollie payment url
 */
export const getMolliePayment = (
  config: TideClientConfig,
  request: MolliePaymentRequest,
  signal?: AbortSignal
): Promise<MolliePayment> => {
  const url = `${config.host}${ENDPOINT_CREATE_PAYMENTS}`;
  const apiKey = config.apiKey;
  const body = JSON.stringify(request);

  return post(url, apiKey, body, config.token, signal);
};
